import { createContext, useCallback, useContext, useEffect, useState } from 'react'

import useAuth from 'lib/auth'
import { addDoc, getDocs, setDoc, updateDoc, where } from 'lib/firestore'

const AccountContext = createContext()

export function AccountProvider({ children }) {
  const { user } = useAuth()
  const [accounts, setAccounts] = useState(null)

  useEffect(() => {
    if (user) {
      // FIXME: useDocs に差し替えたいが collectionGroup で動作確認できなかった
      getDocs('*/members', where('email', '==', user.email)).then(docs => {
        const data = docs.map(member => {
          if (!member.uid || !member.name) {
            updateDoc(`accounts/${member.account.id}/members/${member.id}`, {
              uid: user.uid,
              name: user.displayName,
            })
          }
          return {
            ...member.account,
            role: member.role,
            locationId: member.locationId,
            notify: member.notify,
          }
        })
        setAccounts(data)
      })
    }
  }, [user])

  const createAccount = useCallback(
    async (accountName, locationName, contact = {}, isPrivate) => {
      const doc = await addDoc('accounts', {
        name: accountName,
        creator: user.uid,
        contact,
        isPrivate,
      })
      await setDoc(`accounts/${doc.id}/members/${user.email}`, {
        uid: user.uid,
        email: user.email,
        role: 'owner',
        account: { id: doc.id, name: accountName },
        notify: { monthly: true, daily: true },
      })
      await addDoc(`accounts/${doc.id}/locations`, {
        name: locationName,
        contact,
        deleted: false,
      })
      setAccounts(current => {
        if (current.some(x => x.id === doc.id)) {
          return current
        }
        return current.concat([{ id: doc.id, name: accountName }])
      })
      return { id: doc.id, name: accountName }
    },
    [user]
  )

  const clearAccounts = useCallback(() => setAccounts(null), [])

  return (
    <AccountContext.Provider
      value={{ accounts, createAccount, clearAccounts }}
      children={children}
    />
  )
}

export function useAccount() {
  return useContext(AccountContext)
}
